import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { adoptSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clear the hash from URL immediately
    if (window.history?.replaceState) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true },
        );
        adoptSession(data.token, data.user);
        toast.success("Welcome to T.A.C.C.");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        toast.error(err.response?.data?.detail || "Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, adoptSession]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">
      <div className="font-mono text-[11px] tracking-[0.4em] uppercase text-[#78716C] animate-pulse">
        Signing you in…
      </div>
    </main>
  );
}
